import { ILogger } from "@tdp/common/telemetry";
import { IPeoplePickerReader } from "./IPeoplePickerReader";
import { createCommands } from "@tdp/common/commandHandler";
import { ApiFetchStatus } from "@tdp/common/constants";
import { peoplePickerSlice } from "./peoplePickerSlice";

export interface IPeoplePickerCommandHandler {
  logger: ILogger;
  peoplePicker: IPeoplePickerReader;
}


export const createPeoplePickerCommands = ({ logger, peoplePicker }: IPeoplePickerCommandHandler) =>
  createCommands(
    {
      name: "peoplePickerCommands",
      handlers: {
        async *queryUsers(input: string) {
          const response = await peoplePicker.readUsers(input);
          if (response.type === ApiFetchStatus.SUCCESS && response.response) {
            yield peoplePickerSlice.actions.setUsers(response.response);
          }
        },
      }
    }
  );